export default {
    key: "electronicsMarket",
    basePath: "/electronicsMarket",
    exclude: false,
    components: [],
};
